import clsx from 'clsx'
import React from 'react'
import { useTranslation } from 'react-i18next'

import style from './FleetStats.module.css'

interface FleetStatsProps {
  overall: number
  online: number
  active: number
  className?: string
}

const FleetStats: React.FC<FleetStatsProps> = ({ overall, online, active, className }) => {
  const { t } = useTranslation()

  return (
    <div className={clsx(style.fleetStatsContainer, className)}>
      <div className={style.fleetStatsGrid}>
        <div className={style.statCard}>
          <div className={style.statLabel}>{t('common.overall')}</div>
          <div className={style.statValue}>{overall}</div>
        </div>
        <div className={style.statCard}>
          <div className={style.statLabel}>{t('common.online')}</div>
          <div className={style.statValue}>{online}</div>
        </div>
        <div className={style.statCard}>
          <div className={style.statLabel}>{t('common.active')}</div>
          <div className={style.statValue}>{active}</div>
        </div>
      </div>
    </div>
  )
}

export default FleetStats
